import AxiosConfig from '@/config/axios-config'

export const SimuladoAPI = {

  listarMeusSimulados () {
    return AxiosConfig.secureJalekoAPI().get('/simuladolista').then(response => response.data)
  },

  listarEstruturaCriacaoSimulado () {
    return AxiosConfig.secureJalekoAPI().get('/simulado/categoria').then(response => response.data)
  },

  listarSimuladosEmDisciplinas () {
    return AxiosConfig.secureJalekoAPI().get('/simuladolista/categoria/disciplina').then(response => response.data)
  },

  listarSimuladosEmSistemas () {
    return AxiosConfig.secureJalekoAPI().get('/simuladolista/categoria/sistema').then(response => response.data)
  },

  removerSimulado (simuladoId) {
    return AxiosConfig.secureJalekoAPI().delete(`/simuladolista/${simuladoId}`).then(response => response.data)
  },

  obterQuestaoSimulado (simuladoId, ordemQuestao) {
    if (!ordemQuestao) {
      ordemQuestao = 1
    }

    return AxiosConfig.secureJalekoAPI().get(`/simulado/${simuladoId}/questao/${ordemQuestao}`).then(response => response.data)
  },

  registrarResposta (simuladoId, ordemQuestao, idResposta) {
    return AxiosConfig.secureJalekoAPI().post(`simulado/${simuladoId}/questao/${ordemQuestao}/registrar-resposta`, { resposta: idResposta }).then(response => response.data)
  },

  limparResposta (simuladoId, ordemQuestao) {
    return AxiosConfig.secureJalekoAPI().delete(`simulado/${simuladoId}/questao/${ordemQuestao}/limpar-resposta`).then(response => response.data)
  },

  obterResultado (simuladoId) {
    return AxiosConfig.secureJalekoAPI().get(`/simulado/${simuladoId}/resultado`).then(response => response.data)
  },

  obterResultadoPorTema (simuladoId) {
    return AxiosConfig.secureJalekoAPI().get(`/simulado/${simuladoId}/resultado-por-tema`).then(response => response.data)
  },

  obterTempoRealizacaoSimulado (simuladoId) {
    return AxiosConfig.secureJalekoAPI().get(`/simulado/${simuladoId}/prova-tempo`).then(response => response.data)
  },

  finalizar (simuladoId) {
    return AxiosConfig.secureJalekoAPI().post(`/simulado/${simuladoId}/finalizar`).then(response => response.data)
  },

  criarSimuladoUsandoModelo (idSimulado) {
    return AxiosConfig.secureJalekoAPI().post(`simulado/modelo/${idSimulado}/criar-simulado`).then(response => response.data)
  },

  refazer (idSimulado) {
    return AxiosConfig.secureJalekoAPI().get(`simulado/${idSimulado}/questao/1/refazer`).then(response => response.data)
  },

  gravarTempo (idSimulado, tempo) {
    return AxiosConfig.secureJalekoAPI().post(`simulado/${idSimulado}/grava-tempo`, { tempo_realizado: tempo }).then(response => response.data)
  },

  comecarQuiz (modeloId) {
    return AxiosConfig.secureJalekoAPI().post(`simulado/modelo/${modeloId}/criar-quiz`).then(response => response.data)
  },

  limparRespostaQuiz (quizId, ordem) {
    return AxiosConfig.secureJalekoAPI().delete(`simulado/${quizId}/questao/${ordem}/limpar-resposta`).then(response => response.data)
  },

  registrarRespostaQuiz (quizId, ordem, idOpcao) {
    return AxiosConfig.secureJalekoAPI().post(`simulado/${quizId}/questao/${ordem}/registrar-resposta`, { resposta: idOpcao }).then(response => response.data)
  }

}

export default SimuladoAPI
